import { IPost, IPostMetadata, IPostRedirect } from "interfaces/interfaces";

const ADMIN_API_ENDPOINT = process.env.REACT_APP_ADMIN_API;

export const BlogAPI = {
  list: async (request: {
    start_key?: string;
    tags?: string[];
    query?: string;
    amount?: number;
  }): Promise<{ data: IPostMetadata[]; last_key: string } | null> => {
    return fetch(ADMIN_API_ENDPOINT + "blog/public/list", {
      mode: "cors",
      method: "POST",
      credentials: "same-origin",
      body: JSON.stringify({
        start_key: request.start_key,
        amount: request.amount ?? 9,
        tags: request.tags,
        query: request.query
      })
    }).then(async (data) => {
      if (data.ok) {
        return await data.json();
      } else {
        return null;
      }
    });
  },

  get: async (post_id: string): Promise<IPost | IPostRedirect | null> => {
    return fetch(ADMIN_API_ENDPOINT + "blog/public/post/" + post_id, {
      mode: "cors",
      method: "GET",
      credentials: "same-origin"
    }).then(async (data) => {
      if (data.ok) {
        return (await data.json()) as IPost | IPostRedirect;
      } else {
        return null;
      }
    });
  }
};
